import colors from './colors';
const shadows = {
  toolbar: `0px 1px 0px ${colors.toolbar}`,
  button: `rgb(0 0 0 / 12%) 0px 1px 6px, rgb(0 0 0 / 12%) 0px 1px 4px`,
};

export default shadows;
